import React, { useState } from 'react';
import { FiPlay, FiFileText, FiClock, FiSettings, FiDownload, FiSend } from 'react-icons/fi';
import Cookies from 'js-cookie';
import RunPayroll from './components/RunPayroll';
import PayslipHistory from './components/PayslipHistory';
import TimeTracking from './components/TimeTracking';
import PayrollSettings from './components/PayrollSettings';
import AbaPayRuns from './components/AbaPayRuns';
import STPSubmissions from './components/STPSubmissions';
import { canViewAbaPayRuns, canViewSTP } from '../../utils/permissions';
import './styles/PayrollDashboard.css';
import { useAdminPageSearch } from '../../utils/useAdminPageSearch';

const BASE_NAV_ITEMS = [
    { key: 'settings', label: 'Payroll Settings', icon: <FiSettings size={16} /> },
    { key: 'time',     label: 'Time Tracking',    icon: <FiClock size={16} /> },
    { key: 'run',      label: 'Run Payroll',      icon: <FiPlay size={16} /> },
    { key: 'history',  label: 'Payslip History',  icon: <FiFileText size={16} /> },
];

export default function PayrollDashboard() {
    const { get, patch } = useAdminPageSearch();
    const [timesheetSearch, setTimesheetSearch] = useState('');
    const cookieCompanyName = Cookies.get('companyName') || '';
    const localCompanyName = localStorage.getItem('companyName') || '';
    const rawCompanyName = (cookieCompanyName || localCompanyName || '').trim();
    const normalizedCompanyName = rawCompanyName.toLowerCase();
    const companyName = rawCompanyName && !normalizedCompanyName.includes('admin')
        ? rawCompanyName
        : 'Company';

    const userRoles       = JSON.parse(localStorage.getItem('userRoles'))       || [];
    const userPermissions = JSON.parse(localStorage.getItem('userPermissions')) || [];
    const showAba = canViewAbaPayRuns(userRoles, userPermissions);
    const showSTP = canViewSTP(userRoles);

    const NAV_ITEMS = [
        ...BASE_NAV_ITEMS,
        ...(showAba ? [{ key: 'aba', label: 'ABA Pay Runs', icon: <FiDownload size={16} /> }] : []),
        ...(showSTP ? [{ key: 'stp', label: 'STP',          icon: <FiSend size={16} /> }] : []),
    ];
    const urlTab = get('tab');
    const active = NAV_ITEMS.some((item) => item.key === urlTab)
        ? urlTab
        : 'settings';
    const goTab = (key) => patch({ tab: key === 'settings' ? '' : key });

    return (
        <div className="cpay-layout">
            {/* Inner Sidebar */}
            <aside className="cpay-sidebar">
                <div className="cpay-brand">
                    <div className="cpay-brand-name">{companyName}</div>
                    <div className="cpay-brand-sub">Payroll System</div>
                </div>
                <nav className="cpay-nav">
                    {NAV_ITEMS.map(item => (
                        <button
                            key={item.key}
                            className={`cpay-nav-item${active === item.key ? ' active' : ''}`}
                            onClick={() => { if (item.key === 'time') setTimesheetSearch(''); goTab(item.key); }}
                        >
                            {item.icon}
                            {item.label}
                        </button>
                    ))}
                </nav>
            </aside>

            {/* Content */}
            <div className="cpay-content">
                {active === 'run'      && <RunPayroll
                    onPayrollComplete={() => goTab('history')}
                    onViewTimesheet={(name) => { setTimesheetSearch(name); goTab('time'); }}
                    onGoToAbaRuns={() => goTab('aba')}
                />}
                {active === 'history'  && <PayslipHistory />}
                {active === 'time'     && <TimeTracking key={timesheetSearch} initialSearch={timesheetSearch} />}
                {active === 'settings' && <PayrollSettings userRoles={userRoles} />}
                {active === 'aba'      && <AbaPayRuns />}
                {active === 'stp'      && <STPSubmissions />}
            </div>
        </div>
    );
}
